import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPinterest$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPinterest extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ff65f25c9489011fa65b86eeb9fbe4e2002134d5', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '68f9c5a1203192b33f35b987de04a710f062b366', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '1cd841a2d652fc714399c0d2d98a486b0455a364', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.002 2A9 9 0 0 0 7.72 19.38a8.7 8.7 0 0 1 0-2.588c.168-.698 1.057-4.5 1.057-4.5A3.3 3.3 0 0 1 8.54 11c0-1.249.73-2.182 1.63-2.182a1.124 1.124 0 0 1 1.124 1.26 18.7 18.7 0 0 1-.742 3.003 1.305 1.305 0 0 0 1.327 1.62c1.597 0 2.834-1.688 2.834-4.117a3.544 3.544 0 0 0-3.71-3.667 3.89 3.89 0 0 0-4.071 3.903 3.47 3.47 0 0 0 .697 2.047c.06.072.082.169.056.259-.067.292-.214.9-.247 1.024-.034.123-.124.202-.293.123a4.05 4.05 0 0 1-1.833-3.487c-.056-2.846 2.002-5.41 5.892-5.41a5.273 5.273 0 0 1 5.544 5.196c0 3.094-1.957 5.625-4.666 5.625a2.42 2.42 0 0 1-2.07-1.035s-.45 1.72-.55 2.148a10.3 10.3 0 0 1-1.125 2.351 9.1 9.1 0 0 0 2.665.338c4.968 0 8.996-4.03 8.996-9S15.97 2 11.002 2", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-pinterest", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-pinterest"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-pinterest":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPinterest$1);
            }
            break;
    } });
}

const CosmosIconPinterest = CosmosIconPinterest$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPinterest, defineCustomElement };
